/**
 * Pure colour helpers shared by the canvas effects.
 * Kept framework-free and DOM-free so they can be unit tested with `bun test`.
 */

/** Linearly interpolate between `a` and `b` by `t` (0–1), rounded to an integer. */
export function mix(a: number, b: number, t: number): number {
  return Math.round(a + (b - a) * t);
}

/**
 * Blend the brand teal (#2fe6c4) into the icy blue (#6cb8ff).
 * Returns an "r,g,b" string ready to drop into `rgba(<here>, alpha)`.
 * `t = 0` → teal, `t = 1` → ice.
 */
export function tealIce(t: number): string {
  return `${mix(47, 108, t)},${mix(230, 184, t)},${mix(196, 255, t)}`;
}
